<template>
    <div class="FM_withdrawalList">
		<el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="withdrawalForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="withdrawalForm.phone" placeholder="请输入代理商手机号"></el-input>
                </el-form-item>
              <el-form-item>
                <el-input size clearable v-model="withdrawalForm.agent_no" placeholder="请输入代理编号"></el-input>
              </el-form-item>
			  <el-form-item>
			      <el-select
			          size
			          v-model="withdrawalForm.is_deal"
			          clearable
			          placeholder="请选择审核状态"
			      >
			          <el-option label="全部" value="-1"></el-option>
			          <el-option label="未审核" value="0"></el-option>
					  <el-option label="未完成" value="1"></el-option>
					  <el-option label="完成扣款" value="2"></el-option>
					  <el-option label="已拒绝" value="3"></el-option>
			      </el-select>
			  </el-form-item>
			  <el-form-item>
			      <el-select
			          size
			          v-model="withdrawalForm.reason_type"
			          clearable
			          placeholder="请选择扣款原因"
			      >
			          <el-option label="全部" value="-1"></el-option>
			          <el-option label="机具未激活" value="1"></el-option>
					  <el-option label="商户伪激活" value="2"></el-option>
					  <el-option label="流量卡" value="3"></el-option>
					  <el-option label="快递费" value="4"></el-option>
					  <el-option label="税点扣款" value="5"></el-option>
					  <el-option label="监管罚款" value="6"></el-option>
					  <el-option label="抵扣货款" value="7"></el-option>
					  <el-option label="业务开通费" value="8"></el-option>
					  <el-option label="其他" value="9"></el-option>
			      </el-select>
			  </el-form-item>
			  <el-form-item>
			      <el-date-picker
			          v-model="createDate"
			          type="datetimerange"
			          range-separator="至"
			          start-placeholder="申请开始日期"
			          end-placeholder="申请结束日期"
			          value-format="yyyy-MM-dd HH:mm:ss"
			          @change="createChange"
			      ></el-date-picker>
			  </el-form-item>
			  <el-form-item>
			      <el-date-picker
			          v-model="examineDate"
			          type="datetimerange"
			          range-separator="至"
			          start-placeholder="审核开始日期"
			          end-placeholder="审核结束日期"
			          value-format="yyyy-MM-dd HH:mm:ss"
			          @change="examineChange"
			      ></el-date-picker>
			  </el-form-item>
<!--                <el-form-item>
                    <el-input size clearable v-model="withdrawalForm.m_phone" placeholder="请输入商户手机号"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="handleSearchs(withdrawalForm)"
                    >查询</el-button>
					<el-button
					        size="medium"
					        type="primary"
					        icon="el-icon-download"
					        style="font-size: 12px;"
							:loading="downLoading"
					        @click="handledownload(withdrawalForm)"
					>导出</el-button>
                  <el-button
                      size="medium"
                      type="primary"
                      icon="el-icon-check"
                      style="font-size: 12px;"
                      :loading="downLoading"
                      @click="examineList(1)"
                  >审核</el-button>
<!--					<el-button-->
<!--					        size="medium"-->
<!--					        type="primary"-->
<!--					        style="font-size: 12px;"-->
<!--							@click="handleUndo()"-->
<!--					>添加罚款</el-button>-->
                  <el-button size="medium" type="primary" icon="el-icon-plus" @click="addStock">批量导入罚款</el-button>
                </el-form-item>

            </el-form>
        </el-card>
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="withdrawalTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
                    @selection-change="handleSelectionChange">
              <el-table-column
                  type="selection"
                  :selectable="selectable"
                  width="55">
              </el-table-column>
                <el-table-column
					header-align="center"
					align="center"
					fixed
					type="index"
					label="ID"
					min-width="80"
                ></el-table-column>
				<!-- 代理姓名 -->
				<el-table-column
				        header-align="center"
				        align="center"
				        prop="agent_no"
				        label="代理商编号"
				        min-width="120"
				></el-table-column>
                <!-- 代理姓名 -->
                <el-table-column
					header-align="center"
					align="center"
					prop="nickname"
					label="代理商名称"
					min-width="120"
                ></el-table-column>
	            <!-- 罚款人 -->
	            <el-table-column
		            header-align="center"
		            align="center"
		            prop="phone"
		            label="代理商账号"
                    min-width="130"
	            >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                    <p>{{ scope.row.phone | desMobile }}</p>
                  </el-tooltip>
                </template>
              </el-table-column>
				<!-- 扣除账户 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="deduction_amount"
				    label="金额"
				    min-width="80"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="had_money"
				    label="已扣金额"
				    min-width="80"
				></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="not_money"
				    label="待扣金额"
				    min-width="80"
				></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="account_type_list"
            label="扣款账户"
            min-width="160"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="type_text"
            label="是否逐级扣款"
            min-width="100"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="is_invoice_text"
            label="是否影响开票"
            min-width="100"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="reason_type_text"
            label="扣款原因"
            min-width="160"
        ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="is_deal_text"
				    label="状态"
				    min-width="80"
				></el-table-column>
                <!-- 申请时间 -->
                <el-table-column
					header-align="center"
					align="center"
					prop="create_time"
					label="申请时间"
					min-width="150"
                ></el-table-column>
              <!-- 审核时间 -->
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="examine_time"
                  label="审核时间"
                  min-width="150"
              ></el-table-column>
              <!-- 完成时间 -->
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="complete_time"
                  label="完成时间"
                  min-width="150"
              ></el-table-column>
              <!-- 审核备注 -->
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="remarks"
                  label="审核备注"
                  min-width="150"
              ></el-table-column>
              <!-- 备注说明 -->
                <el-table-column
					header-align="center"
					align="center"
					fixed="right"
					label="扣款详情"
					min-width="120"
                >
                    <template slot-scope="scope">
                        <el-button
							v-show="true"
							@click="detailsShow(scope.row)"
							type="text"
							size="small"
                        >查看</el-button>
                      <el-button
                          v-if="scope.row.is_deal == 0"
                          v-show="true"
                          @click="examineList(2,scope.row)"
                          type="text"
                          size="small"
                      >审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :total="page.total"
                    @watchCurrent="getCurrent"
                    @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <!-- 审核&详情 -->
        <info-audit
                v-if="infoIsShow"
                :infoIsShow="infoIsShow"
                :dialogData="dialogData"
                @infoClose="infoClose"
        ></info-audit>
        <!-- 审核&详情 -->
        <deduction-detail
                v-if="detailIsShow"
                :detailIsShow="detailIsShow"
                :dialogData="dialogData"
                @infoClose="infoClose"
        ></deduction-detail>
<!--//导入-->
      <stock-tools
          v-if="toolsIsShow"
          :toolsIsShow="toolsIsShow"
          @toolsClose="toolsClose"
      ></stock-tools>

<!--      审核弹框-->
      <el-dialog
          title="批量审核"
          width="50%"
          :visible="examineDia"
          :close-on-click-modal="false"
          @close="handleClose"
      >
        <el-form label-position="right" label-width="80px" :model="examineForm">
          <el-form-item label="审核类型">
            <el-radio v-model="examineForm.type" label="1">审核通过</el-radio>
            <el-radio v-model="examineForm.type" label="2">审核拒绝</el-radio>
          </el-form-item>
          <el-form-item label="审核备注">
            <el-input type="textarea" v-model="examineForm.remarks" maxlength="50" placeholder="审核备注限50字，审核拒绝时必填"></el-input>
          </el-form-item>

          <el-button type="primary" style="margin-top:10px;" @click="submit">提交审核</el-button>

          <el-collapse-transition>
            <el-form-item v-if="statusIsShow">
              <div class="titleTip">数据状态</div>
              <div class="tips">共计数据:{{dataStatus.total}}条</div>
              <div class="tips">成功数据:{{dataStatus.successCount}}条</div>
              <div class="tips">完成扣款:{{dataStatus.completeCount}}条</div>
              <div class="tips">扣款总金额:{{dataStatus.totalMoney}}元</div>
              <div class="tips" v-if="dataStatus.errorData">
                <span style="color:#D9001B">*导出失败数据</span>
                <el-link type="primary" :href="dataStatus.errorData">下载失败数据</el-link>
              </div>
            </el-form-item>
          </el-collapse-transition>
        </el-form>
      </el-dialog>
    </div>

</template>

<script>
    import paginations from '../../../components/pagination/paginations';
    import infoAudit from './FM_dealpunishinfo';
    import deductionDetail from './FM_details';
    import stockTools from './FM_stockTools';
    export default {
        name: "FM_dealpunish",
        data() {
            return {
				createDate: '', //时间范围
				examineDate:"",
              statusIsShow:false,
              dataStatus:{},
              examineDia:false,
              examineForm:{
                ids:'',
              },
              multipleSelection:[],
              toolsIsShow: false, //导入、删除库存
                level: sessionStorage.getItem('level'),
                withdrawalTable: [], //表格
                wTable: [], //表格
                infoIsShow: false, //审核弹窗
                detailIsShow: false, //查看详情弹窗
                dialogData: {
                    data: {} //当前行的数据
                },
                withdrawalForm: {
                    page:'1',
                    limit:'10',
                    phone:'',//代理账号
                    agent_no:'',//代理编号
					start_create_time:'',
					end_create_time:'',
					start_examine_time:'',
					end_examine_time:'',
					is_deal:'',
					reason_type:'',
                },
                page: {
                    currentPage: 1, //当前页码
                    pageSize: 10, //条数
                    total: 0  //总数
                },
                loading: true,
                downLoading: false //loading
            }
        },
        mounted() {
            this.getData( //初始化
                {
                    page: 1,
                    limit: this.page.pageSize
                }
            );
        },
        components: {
            paginations,
            infoAudit,
            deductionDetail,
            stockTools,
        },
        methods: {
			createChange(DateArr) { //时间选择器
			    this.withdrawalForm.start_create_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
			    this.withdrawalForm.end_create_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			examineChange(DateArr) { //时间选择器
			    this.withdrawalForm.start_examine_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
			    this.withdrawalForm.end_examine_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
          handleSelectionChange(val){
            this.multipleSelection = val;
          },
          handleClose(){
            this.examineDia = false;
            this.examineForm = {};
          },
          examineList(can,row){
            this.statusIsShow = false;
            this.dataStatus = {};
            if(can == 1){
              if(this.multipleSelection){
                let arr = [];
                this.multipleSelection.map(res=>{
                  arr.push(res.id)
                })
                this.examineForm.ids = arr.join(',');
              }
            }else{
              this.examineForm.ids = row.id;
            }
            this.examineDia = true;
          },
          submit(){
            this.$api.post("user/penalty_deduction_examine", this.examineForm, res => {
              if (res.code == 0) {
                let data = res.data;
                this.dataStatus = data;
                this.statusIsShow = true;
                this.getData(this.withdrawalForm);
              } else {
                this.$message.error(res.msg);
              }
              //渲染结束后取消加载
              this.loading = false;
            })
          },
          selectable(row,index){
            if(row.is_deal == 0){
              return true
            }else{
              return false
            }
          },
          addStock() {
            this.toolsIsShow = true;
          },
          toolsClose(ref) { //关闭导入、删除库存
            this.toolsIsShow = false;
            if (ref) { //重载表格
              this.getData({
                page: this.page.currentPage,
                limit: this.page.pageSize
              })
            }
          },
			handleUndo() { //添加处罚
			    this.infoIsShow = true;
			},
			infoClose(ref) {
			    this.infoIsShow = false;
			    this.detailIsShow = false;
			    if (ref) {
			        this.getData(this.withdrawalForm);//刷新
			    }
			},
			getData(params) { //获取列表
			    this.loading = true;
			    this.$api.post("user/penalty_deduction_list", params, res => {
			        if (res.code == 0) {
			            let data = res.data;
			            this.page.total = data.count; //总数
			            this.withdrawalTable = data.list;
			        } else {
			            this.$message.error(res.msg);
			        }
			        //渲染结束后取消加载
			        this.loading = false;
			    })
			},
            handleSearchs(withdrawalForm){
                // 表单提交
                this.getData(withdrawalForm);
            },
			handledownload(withdrawalForm){
				let reqData = {
					type: 3,
					value: JSON.stringify(withdrawalForm)
				};
				
				this.downLoading = true; 
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
				})
			},

            detailsShow(row) { //查看处罚详情
                this.detailIsShow = true;
                this.dialogData.data = row;
            },
			//分页
			getCurrent(page) {
			    // 获取当前页修改的值
			    this.page.currentPage = page;
			    this.withdrawalForm.page = this.page.currentPage;
			    this.withdrawalForm.limit = this.page.pageSize;
			    this.getData(this.withdrawalForm);
			},
			getPageSize(limit) {
			    this.page.currentPage = 1; //重置分页
			    // 获取条数发生改变的值
			    this.page.pageSize = limit;
			    this.withdrawalForm.page = this.page.currentPage;
			    this.withdrawalForm.limit = limit;
			    this.getData(this.withdrawalForm);
			},
        },
    };
</script>

<style lang="scss" scope>
    .FM_withdrawalList {
        .batchTitle {
            font-size: 12px;
            margin: 20px 0;
            :nth-child(1) {
                font-weight: 700;
                color: #1e1e1e;
            }
        }
        // .el-dialog__header {
        //     padding: 20px 20px 0px;
        // }
        .el-dialog__body {
            padding: 0px 20px 30px 20px;
        }
        // .el-input__inner {
        //     font-size: 12px;
        // }
        // .el-form-item {
        //     margin-bottom: 5px;
        // }
        .el-dialog {
            display: flex;
            flex-direction: column;
            margin: 0 !important;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            /*height:600px;*/
            max-height: calc(100% - 30px);
            max-width: calc(100% - 30px);
        }
        .el-dialog .el-dialog__body {
            flex: 1;
            overflow: auto;
        }
    }
</style>
